import * as types from "./types";

const mutations = {
    [types.LOADING_TENANT](state, value) {
        state.loading = value;
    },
    [types.GET_TENANT_LIST](state, tenants) {
        state.tenants = tenants;
    },
    [types.UPDATE_TENANT](state, tenant) {        
        const TenantIndex = state.tenants.findIndex((x) => x.id === tenant.id);
        state.tenants[TenantIndex] = tenant;        
    },
    [types.UPDATE_TENANT_DETAILS](state, tenant) {        
        const TenantIndex = state.tenants.findIndex((x) => x.id === tenant.id);
        state.tenants[TenantIndex] = tenant;        
    },
    [types.GET_TENANT_ID](state, tenantsId) {
        state.tenantsId = tenantsId;
    },
    [types.ADD_TENANT](state, tenants) {
        state.tenants.unshift(tenants);
    },
    [types.GET_TENANT_FIELDS](state, tenantFields) {
        state.tenantFields = tenantFields;
    },
    [types.LOADING_MODULE](state, value) {
        state.loadingModule = value;
    },
    [types.LOADING_LOGS](state, value) {
        state.loadingModule = value;
    },
    [types.GET_USER_LOGS](state, logs) {
        state.logs = logs;
    },
    [types.ADD_SIGNATURE](state, signature) {        
        state.signature.unshift(signature);
    },
    [types.GET_SIGNATURE_BYID](state, moduletype, id) { 
        console.log("🚀 ~ signatureid:", moduletype)       
        state.id = id;
        state.moduletype = moduletype;
    },
};
    

export default mutations;